import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const text = t("marquee");
  return (
    <div className="relative py-6 border-y border-[#00F0FF]/10 bg-[#04060a] overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((n) => (
          <span key={n} className="font-display text-3xl sm:text-4xl uppercase tracking-[0.3em] whitespace-nowrap pr-4">
            <span className="text-outline">{text}</span>
            <span className="neon opacity-60">{text}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
